import { initializeApp } from 'firebase/app'
import { getMessaging, getToken } from 'firebase/messaging'
import { getFirestore, collection, addDoc, serverTimestamp } from 'firebase/firestore'
import { createContext } from 'react'

const firebaseConfig = {
  apiKey: 'AIzaSyA5eKY91eDJD2nGwxw6wt9Uc02hStH7__Y',
  authDomain: 'smith-game.firebaseapp.com',
  projectId: 'smith-game',
  storageBucket: 'smith-game.firebasestorage.app',
  messagingSenderId: '55430091767',
  appId: '1:55430091767:web:a6dc30c35aa9aad2fb94f2',
  measurementId: 'G-Q623BRKPZY'
}

const vapidKey = 'BBAAD7sNyJFi_HR5nglEvAtu8v5gFAvFj1Wy1v7ZISrJ4s9dyUDR63xEEFHJ0c83xdq32aJJNaUv5tsysHS1n5M'

// Initialize Firebase
const app = initializeApp(firebaseConfig)
const messaging = getMessaging(app)
const db = getFirestore(app)

// A stable, anonymous per-browser id used only to group feedback ("does one
// person have ten complaints, or do ten people?"). It's a random UUID persisted
// in localStorage — no login, nothing personally identifying. It resets if the
// user clears site data, which is fine for playtesting.
const ANON_ID_KEY = 'anonUserId'

export function getAnonymousUserId () {
  if (typeof localStorage === 'undefined') return null
  let id = localStorage.getItem(ANON_ID_KEY)
  if (!id) {
    id = (typeof crypto !== 'undefined' && crypto.randomUUID)
      ? crypto.randomUUID()
      : `anon-${Date.now()}-${Math.random().toString(36).slice(2)}`
    localStorage.setItem(ANON_ID_KEY, id)
  }
  return id
}

// Playtest feedback. Writes a single document per submission to the `feedback`
// collection. The Firestore security rules (firestore.rules) allow anonymous
// creates only — no reads/updates/deletes from the client — so results are read
// via the Firebase console or an export. `vote` is 1 (👍), -1 (👎) or 0 (comment
// only); `text` is optional free-text. `reduxState` is the entire store snapshot
// at submit time, stored as a JSON string so nested `undefined`s can't reject the
// write and so the game context is captured without any per-scene plumbing.
// `userId` is the anonymous per-browser id so submissions can be grouped by user.
export function submitFeedback ({ vote = 0, text = null, reduxState = null }) {
  return addDoc(collection(db, 'feedback'), {
    vote,
    text: text || null,
    userId: getAnonymousUserId(),
    reduxState: reduxState ? JSON.stringify(reduxState) : null,
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
    createdAt: serverTimestamp()
  })
}

export function requestNotificationsPermission () {
  return Notification.requestPermission()
}

export function getMessagingToken () {
  return getToken(messaging, { vapidKey })
}

export function requestDelayedNotification ({ token, delaySeconds, notification }) {
  fetch('/notifications', {
    method: 'POST',
    body: JSON.stringify({ token, delaySeconds, notification }),
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export const FirebaseMessagingTokenContext = createContext(null)
